export default function StatsSection() {
  const stats = [
    { number: '500+', label: 'Deliveries Monthly' },
    { number: '98%', label: 'On-Time Rate' },
    { number: '24/7', label: 'Customer Support' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-6xl font-bold text-[#E67E50] mb-2">
                {stat.number}
              </div>
              <div className="text-sm font-medium text-gray-600 uppercase tracking-wider">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
